import { useSearchParams } from "react-router-dom";
import type { FileKindFilter, FileSortKey, FileSourceFilter } from "./file-index";

const KINDS = new Set<FileKindFilter>(["all", "image", "file", "link"]);
const SOURCES = new Set<FileSourceFilter>(["all", "task", "record", "comment", "document"]);
const SORTS = new Set<FileSortKey>(["recent", "name", "size"]);

export function useFileListParams() {
  const [params, setParams] = useSearchParams();
  const kind = read(params.get("kind"), KINDS, "all");
  const source = read(params.get("source"), SOURCES, "all");
  const sort = read(params.get("sort"), SORTS, "recent");
  const query = params.get("q") ?? "";
  const planId = params.get("plan") ?? "";

  const patch = (next: Record<string, string | null>) => {
    const updated = new URLSearchParams(params);
    for (const [key, value] of Object.entries(next)) {
      if (!value) updated.delete(key);
      else updated.set(key, value);
    }
    setParams(updated, { replace: true });
  };

  const selectKind = (next: FileKindFilter) => {
    if (next === kind) return;
    patch({ kind: next === "all" ? null : next, q: null });
  };

  return { params, setParams, kind, source, sort, query, planId, patch, selectKind };
}

function read<T extends string>(value: string | null, allowed: Set<T>, fallback: T): T {
  return value && allowed.has(value as T) ? (value as T) : fallback;
}
